const defaultData = {
  card1: true,
  card2: true,
  card3: true,
};

const getDataFromStorage = (storagedData, initialData) => {
  for (const key in storagedData) {
    initialData[key] = storagedData[key];
  }
  return initialData;
};

const initialState = window.localStorage.getItem("cards-indicators-quality")
  ? getDataFromStorage(
      JSON.parse(window.localStorage.getItem("cards-indicators-quality")),
      defaultData,
    )
  : defaultData;

const cardsOfQualityIndicators = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_CARDS_INDICATORS_QUALITY":
      return {
        card1: action.card1,
        card2: action.card2,
        card3: action.card3,
      };
    default:
      return state;
  }
};

export default cardsOfQualityIndicators;
